module.exports = __webpack_public_path__ + "static/media/dashboard@2x.b49663d3.png";